/**
 * The staff assistants' display names, in one place (Gary, 1 Nov 2026). Leo is the customer
 * assistant; the staff Ask assistant is Ted; Seth is the marketing assistant (role key 'marketing'). Mirrors supabase/functions/ask-chat/assistant.ts
 * and apps/chats/src/lib/assistant.ts; keep all three the same.
 */
export const ASSISTANT_NAMES = {
  ted: 'Ted',
  marketing: 'Seth',
  chief_of_staff: 'Gwynne',
  finance: 'Ruth',
} as const;

/** Titles on the virtual team (Gary, 1 Nov 2026). Leo (Chief Customer Officer) is the customer assistant. */
export const ASSISTANT_TITLES = {
  ted: 'Chief Sales Officer, Sales Coach',
  marketing: 'Chief Marketing Officer, Brand Builder',
  chief_of_staff: 'Chief of Staff, Mission Control',
  finance: 'Chief Financial Officer, Finance and Commercial',
} as const;

export type AssistantRole = keyof typeof ASSISTANT_NAMES;

/** Everyone on the AI team, Leo (customers) included. */
export type AiTeamMember = AssistantRole | 'leo';

/**
 * One emblem avatar each (Gary, 1 Nov 2026; mock-up https://claude.ai/artifact/2TvJ6x7rmjHRHbqybxoCXy):
 * Gwynne compass, Leo speech bubble, Ted whistle, Seth spark, Ruth shield. Files in public/ai-team.
 * Mirrors apps/chats/src/lib/assistant.ts (the functions mirror renders nothing, so it has no avatars).
 */
export const ASSISTANT_AVATARS: Record<AiTeamMember, string> = {
  chief_of_staff: '/ai-team/chief_of_staff.svg',
  leo: '/ai-team/leo.svg',
  ted: '/ai-team/ted.svg',
  marketing: '/ai-team/marketing.svg',
  finance: '/ai-team/finance.svg',
};

/** The CMB Management channel's own picture: the team together. */
export const MANAGEMENT_AVATAR = '/ai-team/management.svg';

export const STAFF_ASSISTANT_NAME = ASSISTANT_NAMES.ted;
